import { useMediaQuery } from "@material-ui/core";
import {
	Filter as RaFilter,
	ReferenceInput,
	SelectInput,
} from "ra-ui-materialui";
import React from "react";
import SearchInput from "../components/inputs/SearchInput";
import { useFiltersStyles } from "../components/lists/useStyles";
import statuses from "./statuses";
import syncStatuses from "./syncStatuses";

const Filters = (props) => {
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes} variant="outlined">
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="bookmaker_type_id"
				reference="bookmaker-types"
				alwaysOn={!sm}
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="status"
				choices={statuses}
				alwaysOn
				fullWidth
			/>
			<SelectInput
				source="sync_status"
				choices={syncStatuses}
				emptyText="ra.action.all"
				style={{ minWidth: 220 }}
				alwaysOn
			/>
			<ReferenceInput
				source="bookmaker_platform_id"
				reference="bookmaker-platforms"
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
				sort={{ field: "name", order: "ASC" }}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="language_id"
				reference="languages"
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
				sort={{ field: "id", order: "ASC" }}
				filter={{ is_nation: true }}
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
		</RaFilter>
	);
};

export default Filters;
